module.exports = __webpack_public_path__ + "media/src/website/images/locations/altoetting/altoetting_03-e5cf65fef8cf6e24696ad691782aa840.jpg";